<template>
  <div class="warning-container">
    <div class="warning-text">
      <IconWarningAmber color="#fa8425" /> <strong>Aviso:</strong> {{ text }}
    </div>
  </div>
</template>

<script>
import IconWarningAmber from '@/components/icons/IconWarningAmber.vue';

export default {
  name: 'Warning',
  components: {
    IconWarningAmber,
  },
  props: {
    text: {
      type: String,
      default: 'Existe algum erro no módulo',
    },
  },
};
</script>

<style scoped lang="scss">
.warning-container {
  padding: 36px 0;
}

.warning-text {
  display: table;
  margin: 0 auto;
  padding: 16px 20px;
  border: 2px solid $orange-100;
  border-radius: 8px;
  background: $gray-00;
  font-size: 18px;

  .icon {
    vertical-align: sub;
    margin-right: 8px;
  }

  strong {
    font-weight: 700 !important;
  }
}
</style>
